import { useState, useEffect, useCallback } from 'react';
import { conversationService } from '../services/conversationService';

export const useUnreadCount = (userId: string) => {
  const [totalUnread, setTotalUnread] = useState(0);

  const updateUnreadCount = useCallback(async () => {
    if (!userId) return;
    try {
      const conversations = await conversationService.getConversations(userId);
      const total = conversations.reduce((sum, conv) => sum + conv.unread_count, 0);
      setTotalUnread(total);
    } catch (error) {
      console.error('Error updating unread count:', error);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) return;

    updateUnreadCount();

    // Realtime subscription for conversation changes
    const subscription = conversationService.subscribeToConversations(
      userId,
      updateUnreadCount
    );

    // Instant update when any chat marks messages as read
    const handleChatEvent = () => updateUnreadCount();
    window.addEventListener('chat-unread-changed', handleChatEvent);

    // Re-fetch when user tabs back to the app
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') updateUnreadCount();
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      subscription.unsubscribe();
      window.removeEventListener('chat-unread-changed', handleChatEvent);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [userId, updateUnreadCount]);

  return totalUnread;
};